import { FC, useState, useEffect } from 'react';
import { makeStyles, MenuItem, Select } from '@material-ui/core';

import ManageBrandingService from '../sections/Manage-branding/ManageBrandingService';
import { COUNTRY, STATE } from '../sections/Manage-branding/manageBranding.consts';

interface SelectOptionsProps {
    type: string,
    country?: string,
    updateChange: Function,
    value: string,
    loader: boolean,
    disabledState: boolean,
    validate: (property: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | React.ChangeEvent<{ value: any }>, countryOrStatedata?: string) => void,
}
interface SelectOptionsArray {
    name: string,
    value: string
}

const CountryStateDropdown: FC<SelectOptionsProps> = ({ type, country, updateChange, value, loader, disabledState, validate }: SelectOptionsProps) => {

    const [data, setData] = useState<
        SelectOptionsArray[] | SelectOptionsArray[][] | undefined
    >([])

    useEffect(() => {
        switch (type) {
            case "country":
                setData(ManageBrandingService.COUNTRIES);
                break;
            case "state":
                setData(
                    ManageBrandingService.STATES.find((element) => {
                        return element.name === country;
                    })?.state
                )
                break;
            default:
                setData([]);
        }
    }, [country, type, loader])

    const updateOnChange = (e: React.ChangeEvent<{ value: any }>) => {
        updateChange(
            type,
            e.target.value as string
        );
        validate(type === "country" ? COUNTRY : STATE, e, e.target.value);
    }

    return (
        <>
            <Select
                autoComplete="off"
                labelId={type === "country" ? "Country" : "State"}
                displayEmpty
                disabled={disabledState}
                id={`${type}-select`}
                value={value}
                onChange={(e: React.ChangeEvent<{ value: any }>) => {
                    updateOnChange(e);
                }
                }
                label={type === "country" ? "Country" : "State/Province"}
                onBlur={
                    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
                        validate(type === "country" ? COUNTRY : STATE, event, event.target.value)
                }
            >
                <MenuItem value={'default'}>Select {type === "country" ? "Country" : "State/Province"}</MenuItem>
                {data && data.length > 0 && data.map(
                    (element: any) => {
                        return (
                            <MenuItem
                                key={element.name}
                                value={element.value}
                            >
                                {element.name}
                            </MenuItem>
                        )
                    })
                }
            </Select>
        </>
    )
}

export default CountryStateDropdown;
